import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ENTERPRISE, FREE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { getProductLevelFromApiNameString } from '../_core/features/FeaturesUtils';
import TranslatedFeature from './TranslatedFeature';
import { sortApiNamesByProductLevel } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledTooltipSection = styled.div.withConfig({
  displayName: "ProductFeatureLongLimit__StyledTooltipSection",
  componentId: "sc-7a62tg-0"
})(["&:last-child{margin-bottom:0;}"]);
const getLabelI18nKeyByLevel = level => {
  switch (level) {
    case FREE:
      return `upgrades.featureTable.tooltips.labels.FREE`;
    case STARTER:
      return `upgrades.featureTable.tooltips.labels.STARTER`;
    case PROFESSIONAL:
      return `upgrades.featureTable.tooltips.labels.PROFESSIONAL`;
    case ENTERPRISE:
      return `upgrades.featureTable.tooltips.labels.ENTERPRISE`;
    default:
      return '';
  }
};
const ProductFeatureLongLimit = ({
  feature,
  apiName,
  onlyShowCurrentLongLimit
}) => {
  if (!feature.longLimits || !Object.keys(feature.longLimits).length) {
    return null;
  }

  // sort api names by tier lowest to highest
  const sortedApiNames = onlyShowCurrentLongLimit ? [apiName] : sortApiNamesByProductLevel(Object.keys(feature.longLimits));
  return /*#__PURE__*/_jsx(_Fragment, {
    children: sortedApiNames.map(sortedApiName => {
      const sortedLevel = getProductLevelFromApiNameString(sortedApiName);
      const key = `tooltip-${sortedApiName}-${feature.featureId}-${sortedLevel}`;
      return /*#__PURE__*/_jsxs(StyledTooltipSection, {
        id: key,
        className: "m-bottom-2",
        children: [/*#__PURE__*/_jsxs("b", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: getLabelI18nKeyByLevel(sortedLevel)
          }), /*#__PURE__*/_jsx("span", {
            children: ":"
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(TranslatedFeature, {
            feature: feature,
            productLevel: sortedLevel,
            attribute: "longLimits"
          })
        })]
      }, key);
    })
  });
};
export default ProductFeatureLongLimit;